import { Controller } from "@hotwired/stimulus"

// Amène l'élément dans le champ de vision en douceur à la connexion.
// Utilisé pour révéler le résultat du test IA après analyse (navigation Turbo).
export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.scrollIntoView({ behavior: "smooth", block: "start" })
    })
  }
}
